export default __webpack_public_path__ + "static/media/icon-detailed-records.265c8aea.svg";